(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/coupon/alternatives.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/coupon/alternatives.js');
"use strict";


const ButtonBet = svs.components.ReactButtonBet;
const getOutcomeAriaLabel1X2 = svs.components.poolBetting.ariaUtils.getOutcomeAriaLabel1X2;
class Alternatives extends React.Component {
  constructor(props) {
    super(props);
    this.alternativeClick = this.alternativeClick.bind(this);
  }
  renderAlternative(drawEvent, alternative, index, sportType) {
    var _drawEvent$match, _drawEvent$match2;
    const eventNumber = this.props.eventNumber;
    return React.createElement(ButtonBet, {
      "aria-label": getOutcomeAriaLabel1X2({
        awayParticipant: drawEvent === null || drawEvent === void 0 || (_drawEvent$match = drawEvent.match) === null || _drawEvent$match === void 0 || (_drawEvent$match = _drawEvent$match.participants) === null || _drawEvent$match === void 0 || (_drawEvent$match = _drawEvent$match[0]) === null || _drawEvent$match === void 0 ? void 0 : _drawEvent$match.name,
        eventTypeId: drawEvent === null || drawEvent === void 0 ? void 0 : drawEvent.eventTypeId,
        homeParticipant: drawEvent === null || drawEvent === void 0 || (_drawEvent$match2 = drawEvent.match) === null || _drawEvent$match2 === void 0 || (_drawEvent$match2 = _drawEvent$match2.participants) === null || _drawEvent$match2 === void 0 || (_drawEvent$match2 = _drawEvent$match2[1]) === null || _drawEvent$match2 === void 0 ? void 0 : _drawEvent$match2.name,
        sign: alternative.description,
        sportType
      }),
      autotestId: "r_".concat(eventNumber, "_o_").concat(alternative.outcomeNumber),
      className: "btn-bet-challenge",
      disabled: alternative.description === '',
      key: index,
      label: alternative.description,
      labelStyle: alternative.description.length >= 4 ? {
        padding: '0 4px'
      } : {},
      onClick: _.partial(this.alternativeClick, alternative),
      selected: this.isSelected(alternative.outcomeNumber)
    });
  }
  alternativeClick(alternative, event) {
    const _this$props = this.props,
      selectItemAction = _this$props.selectItemAction,
      draw = _this$props.draw,
      eventNumber = _this$props.eventNumber;
    event.stopPropagation();
    selectItemAction(draw.drawNumber, eventNumber, alternative.outcomeNumber);
  }
  isSelected(outcomeNumber) {
    const _this$props2 = this.props,
      coupon = _this$props2.coupon,
      eventNumber = _this$props2.eventNumber;
    let selected = false;
    if (coupon.drawEvents && coupon.drawEvents[eventNumber]) {
      selected = coupon.drawEvents[eventNumber][outcomeNumber];
    }
    return Boolean(selected);
  }
  render() {
    const _this$props3 = this.props,
      alternatives = _this$props3.alternatives,
      draw = _this$props3.draw,
      eventNumber = _this$props3.eventNumber;
    const mappedAlternatives = alternatives.map((alternative, index) => {
      var _draw$sport;
      return this.renderAlternative(draw.drawEvents[eventNumber - 1], alternative, index, draw === null || draw === void 0 || (_draw$sport = draw.sport) === null || _draw$sport === void 0 ? void 0 : _draw$sport.type);
    });
    return React.createElement("div", {
      className: "simple-row right js-clickable-ignore js-outcomes"
    }, mappedAlternatives);
  }
}
svs.challenge.Alternatives = Alternatives;

 })(window);